import { render, staticRenderFns } from "./SelectProductsDialog.vue?vue&type=template&id=2b1e5980&scoped=true"
import script from "./SelectProductsDialog.vue?vue&type=script&lang=js"
export * from "./SelectProductsDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectProductsDialog.vue?vue&type=style&index=0&id=2b1e5980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1e5980",
  null
  
)

export default component.exports